<mat-form-field appearance="outline" *transloco="let t" subscriptSizing="dynamic">
  <mat-label>{{ t('app.language') }}</mat-label>
  <mat-select [value]="selectedLanguage$ | async" (selectionChange)="languageChanged($event.value)">
    <mat-option value="de">Deutsch</mat-option>
    <mat-option value="en">English</mat-option>
    <mat-option value="fr">Français</mat-option>
    <mat-option value="it">Italiano</mat-option>
  </mat-select>
</mat-form-field>
